import Vue from 'vue'

import { Stack, GetStack, PatchStack } from '@/api/cems'

export default Vue.extend({
  data() {
    return {
      stackUID: '',
      stack: {} as Stack,
    }
  },

  methods: {
    async getStack() {
      this.stack = await GetStack(this.stackUID)
      this.$emit('stackLoaded', this.stack)
    },
    async patchStack() {
      await PatchStack(this.stackUID, this.stack)
      await this.getStack()
    },
  },

  async created() {
    this.stackUID = this.$route.params.stackUID
    await this.getStack()
  },
})
